import { FlexibleObject } from './interface';

export function formatDateOnly(dateTime: string | Date): string {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function downloadFileWithStreaming(
    url: string,
    method: 'GET' | 'POST' | 'PUT',
    payload?: FlexibleObject
): void {
    let ac = sessionStorage.getItem('access_token');
    const accessToken = JSON.parse(ac).accessToken;
    if (!accessToken) {
        console.error('No access token found');
        return;
    };

    const form = document.createElement('form');
    form.method = method;
    form.action = url;
    form.target = '_blank';
    form.style.display = 'none';
    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'access_token';
    tokenInput.value = accessToken;
    form.appendChild(tokenInput);

    if (payload) {
        // const payload = document.createElement('input');
        // payload.type = 'hidden';
        // payload.name = 'payload';
        // payload.value = JSON.stringify(payload);
        // form.appendChild(payload);
        for (const key in payload) {
            if (payload.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value =
                    typeof payload[key] === 'object'
                        ? JSON.stringify(payload[key])
                        : payload[key];
                form.appendChild(input);
            };
        };
    };
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}


export function extractObject(obj: Record<string, any>): { title: string, value: any }[] {
  const result: { title: string, value: any }[] = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const formattedKey = key
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());

      result.push({
        title: formattedKey,
        value: obj[key]
      });
    }
  }

  return result;
}

export function removeKeys<T extends object, K extends keyof T>(obj: T, keysToRemove: K | K[]): Omit<T, K> {
  const keys = Array.isArray(keysToRemove) ? keysToRemove : [keysToRemove];
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key as K))
  ) as Omit<T, K>;
}

export function toTitleSegments(path: string): string[] {
  return path
    .split("/")
    .filter(Boolean)
    .map(segment =>
      segment
        .replace(/[-_]/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    );
}

export function canDisplayImage(url: string | null | undefined): boolean {
  if (!url) return false;

  const trimmed = url.trim();
  if (!trimmed) return false;

  const imageExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
    '.svg'
  ];

  try {
    const parsedUrl = new URL(trimmed);
    return imageExtensions.some(ext =>
      parsedUrl.pathname.toLowerCase().endsWith(ext)
    );
  } catch {
    return false;
  }
}
